import { render, staticRenderFns } from "./CompnowLogo.vue?vue&type=template&id=7d80f584&scoped=true"
import script from "./CompnowLogo.vue?vue&type=script&lang=js"
export * from "./CompnowLogo.vue?vue&type=script&lang=js"
import style0 from "./CompnowLogo.vue?vue&type=style&index=0&id=7d80f584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d80f584",
  null
  
)

export default component.exports